export type SynthesiseDockTab = 'synthesise' | 'idea-box' | 'notepad';

export const SYNTHESISE_DOCK_TAB_ACTIVATED_EVENT = 'synthesise-dock-tab-activated';

const tabs = Array.from(
	document.querySelectorAll<HTMLButtonElement>('[data-synthesise-dock-tab]')
);

const panelIdByTab: Record<SynthesiseDockTab, string> = {
	synthesise: 'synthesise-ai-container',
	'idea-box': 'hearted-container',
	notepad: 'notepad-container',
};

const triggerIdByTab: Record<SynthesiseDockTab, string> = {
	synthesise: 'synthesise-ai',
	'idea-box': 'board-menu-hearted',
	notepad: 'notepad-button',
};

const isDockTab = (value: string | undefined): value is SynthesiseDockTab =>
	value === 'synthesise' || value === 'idea-box' || value === 'notepad';

export const setSynthesiseDockMode = (enabled: boolean): void => {
	document.body.classList.toggle('synthesise-dock-active', enabled);
};

export const setActiveSynthesiseDockTab = (activeTab: SynthesiseDockTab): void => {
	for (const tab of tabs) {
		const selected = tab.dataset.synthesiseDockTab === activeTab;
		tab.classList.toggle('active', selected);
		tab.setAttribute('aria-selected', selected ? 'true' : 'false');
		tab.tabIndex = selected ? 0 : -1;
	}

	if (!document.body.classList.contains('synthesise-dock-active')) return;

	document
		.getElementById('board-menu-hearted')
		?.classList.toggle('buttonActive', activeTab === 'idea-box');
	document
		.getElementById('notepad-button')
		?.classList.toggle('buttonActive', activeTab === 'notepad');
	document
		.getElementById('synthesise-ai')
		?.classList.toggle('buttonActive', activeTab === 'synthesise');
};

export const openSynthesiseDockTab = (tab: SynthesiseDockTab): void => {
	const panel = document.getElementById(panelIdByTab[tab]);
	if (panel && !panel.classList.contains('hidden')) {
		setActiveSynthesiseDockTab(tab);
	} else {
		document.getElementById(triggerIdByTab[tab])?.click();
	}

	window.dispatchEvent(
		new CustomEvent<{ tab: SynthesiseDockTab }>(SYNTHESISE_DOCK_TAB_ACTIVATED_EVENT, {
			detail: { tab },
		})
	);
};

for (const tab of tabs) {
	tab.addEventListener('click', () => {
		const dockTab = tab.dataset.synthesiseDockTab;
		if (isDockTab(dockTab)) openSynthesiseDockTab(dockTab);
	});
}
